import { Link } from "react-router-dom";
import { Instagram, MessageCircle, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "./Brand";
import { INSTAGRAM, INSTAGRAM_URL, WHATSAPP_DISPLAY, waLink } from "../../lib/data";

export const FinalCta = () => (
  <section data-testid="final-cta" className="relative py-28 lg:py-40 overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_60%_at_50%_100%,rgba(232,32,42,0.25),transparent)]" />
    <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10 text-center">
      <Reveal>
        <p className="font-display font-black uppercase text-white leading-[0.92]" style={{ fontSize: "clamp(2.4rem, 8vw, 7.5rem)" }}>
          Sua festa<br />merece uma<br /><span className="text-gold-grad">garra.</span>
        </p>
      </Reveal>
      <Reveal delay={0.15} className="mt-12 flex flex-wrap justify-center gap-3">
        <Link to="/reservar" data-testid="final-cta-booking"
          className="group inline-flex items-center gap-3 rounded-full bg-[#FFD200] text-[#08080C] font-semibold pl-8 pr-2 py-2 hover:bg-white transition-colors">
          Reservar agora
          <span className="w-11 h-11 rounded-full bg-[#08080C] text-[#FFD200] grid place-items-center group-hover:rotate-45 transition-transform duration-300"><ArrowUpRight className="w-5 h-5" /></span>
        </Link>
        <a href={waLink()} target="_blank" rel="noreferrer" data-testid="final-cta-whatsapp"
          className="inline-flex items-center gap-2 rounded-full border border-white/20 text-white px-8 py-4 hover:border-[#FFD200] hover:text-[#FFD200] transition-colors">
          <MessageCircle className="w-5 h-5" /> Tirar dúvidas
        </a>
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#050508]">
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 grid md:grid-cols-12 gap-10 items-center">
      <div className="md:col-span-4">
        <img src="/brand/logo-sm.png" alt="Play Toys" className="w-40" />
      </div>
      <div className="md:col-span-5 space-y-3">
        <p className="italic text-zinc-300">Diversão que conquista <b className="text-white not-italic">todas as idades.</b></p>
        <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 text-white hover:text-[#FFD200] transition-colors">
          <Instagram className="w-5 h-5 text-[#FFD200]" /> @{INSTAGRAM}
        </a>
        <a href={waLink()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-white hover:text-[#FFD200] transition-colors">
          <MessageCircle className="w-5 h-5 text-[#FFD200]" /> {WHATSAPP_DISPLAY}
        </a>
      </div>
      <div className="md:col-span-3 flex flex-col gap-2 md:items-end text-sm">
        <Link to="/reservar" className="text-white hover:text-[#FFD200]" data-testid="footer-reservar">Reservar data</Link>
        <Link to="/admin/login" className="text-zinc-400 hover:text-white" data-testid="footer-admin-link">Área do administrador</Link>
      </div>
    </div>
    <p className="text-center text-xs text-zinc-400 pb-8">© {new Date().getFullYear()} Play Toys · Espírito Santo</p>
  </footer>
);

export const WhatsAppFab = () => (
  <motion.a href={waLink()} target="_blank" rel="noreferrer" data-testid="whatsapp-direct-button" aria-label="WhatsApp"
    initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 2, type: "spring" }} whileHover={{ scale: 1.08 }}
    className="fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-[0_10px_30px_rgba(37,211,102,0.45)]">
    <MessageCircle className="w-6 h-6" />
  </motion.a>
);
